"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatFullName = void 0;
function formatFullName(field, value) {
    var _a;
    if (typeof value === "string") {
        return value;
    }
    if (!value) {
        return "";
    }
    const { display_fields: displayFields = [], choices = [] } = field.params;
    const name = [];
    const hasTitle = displayFields.includes("title");
    const hasMiddleName = displayFields.includes("middle_name");
    if (hasTitle) {
        const title = choices.find((choice) => choice.value === value.title);
        name.push((_a = title === null || title === void 0 ? void 0 : title.label) !== null && _a !== void 0 ? _a : "");
    }
    name.push(value.first_name);
    if (hasMiddleName) {
        name.push(value.middle_name);
    }
    name.push(value.last_name);
    return name.filter((part) => !!part).join(" ");
}
exports.formatFullName = formatFullName;
